import BasicTable from "@/components/table/Table";
import { ArrowBackIosIcon } from "@/icons";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

function CustomCard(props) {
  const { title, buttonTitle, handle } = props;
  console.log("props", props);
  console.log("handle", handle);
  const theme = useTheme();
  return (
    <Box>
      <Card>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginBottom={1}
          >
            <Box display="flex" alignItems="center">
              {handle && (<ArrowBackIosIcon fontSize="small" />)}
              <div className=""></div>
              <Typography variant="h5" sx={{ fontWeight: theme.typography.fontWeightBold, lineHeight:"24px" }}>
                {title}
              </Typography>
            </Box>
            {buttonTitle && (
            <Button
              sx={{
                backgroundColor: theme.palette.primary.main,
              }}
              variant="contained"
              onClick={handle}
            >
              {buttonTitle}
            </Button>
            )}
          </Box>
          <Box>
            <BasicTable rows={[]} headers={[]} />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default CustomCard;
